import React from 'react';
import homeScreenImage from '../../../public/static/images/rat-race/home.png';
import styles from './index.module.scss';

const getAssetSrc = (asset) => asset?.src || asset;

export default function RatRaceMotivation() {
  return (
    <section className={styles.motivationSection}>
      <div className={styles.motivationInner}>
        <div className={styles.motivationTextColumn}>
          <h2 className={styles.motivationTitle}>
            Doomscroll Less.
            <br />
            Walk More.
          </h2>
          <p className={styles.motivationBody}>
            Rat Race turns everyday steps into real motivation: lock apps to
            focus, earn rewards to upgrade outfits, climb the leaderboard, and
            most importantly, see what everyone else is wearing.
          </p>
        </div>

        <div className={styles.motivationPhoneArea}>
          <div className={styles.motivationPhoneCanvas}>
            <div className={styles.motivationDashGroup} aria-hidden="true">
              <span
                className={`${styles.motivationDash} ${styles.motivationDashTealOne}`}
              />
              <span
                className={`${styles.motivationDash} ${styles.motivationDashPinkOne}`}
              />
              <span
                className={`${styles.motivationDash} ${styles.motivationDashTealTwo}`}
              />
              <span
                className={`${styles.motivationDash} ${styles.motivationDashPurpleOne}`}
              />
              <span
                className={`${styles.motivationDash} ${styles.motivationDashPinkTwo}`}
              />
              <span
                className={`${styles.motivationDash} ${styles.motivationDashPurpleExtra}`}
              />
            </div>
            <div className={styles.motivationPhoneContainer}>
              <div className={styles.motivationPhoneFrame}>
                <svg
                  className={styles.motivationPhoneOutline}
                  viewBox="0 0 320 643"
                  preserveAspectRatio="none"
                  fill="none"
                  aria-hidden="true"
                >
                  <defs>
                    <linearGradient
                      id="motivation-phone-gradient"
                      x1="0"
                      y1="0"
                      x2="1"
                      y2="0"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="3.09%" stopColor="#FF80B9" />
                      <stop offset="34.78%" stopColor="#B389FA" />
                      <stop offset="66.46%" stopColor="#FFE680" />
                      <stop offset="87.89%" stopColor="#00EADC" />
                      <stop offset="100%" stopColor="#59D1EC" />
                    </linearGradient>
                  </defs>
                  <path
                    fillRule="nonzero"
                    fill="url(#motivation-phone-gradient)"
                    d="M 314.83 101.62 L 314.23 101.62 L 314.23 38.12 C 314.23 17.07 297.09 0 275.94 0 L 43.89 0 C 22.75 0 5.61 17.07 5.61 38.12 L 5.61 101.62 L 5 101.62 C 2.24 101.62 0 103.85 0 106.6 L 0 150.52 C 0 153.27 2.24 155.5 5 155.5 L 5.61 155.5 L 5.61 165.98 L 5 165.98 C 2.24 165.98 0 168.2 0 170.95 L 0 214.88 C 0 217.63 2.24 219.86 5 219.86 L 5.61 219.86 L 5.61 604.53 C 5.61 625.58 22.75 642.65 43.89 642.65 L 275.94 642.65 C 297.09 642.65 314.23 625.58 314.23 604.53 L 314.23 182.44 L 314.83 182.44 C 317.59 182.44 319.83 180.21 319.83 177.46 L 319.83 106.59 C 319.83 103.85 317.6 101.62 314.83 101.62 L 314.83 101.62 Z M 303.09 602.25 C 303.09 619.35 289.17 633.22 271.99 633.22 L 47.84 633.22 C 30.67 633.22 16.75 619.35 16.75 602.25 L 16.75 40.39 C 16.75 23.29 30.67 9.43 47.84 9.43 L 271.99 9.43 C 289.16 9.43 303.08 23.29 303.08 40.39 L 303.08 602.25 L 303.09 602.25 Z"
                  />
                </svg>

                <div className={styles.motivationPhoneScreen}>
                  <img
                    className={styles.motivationMausImage}
                    src={getAssetSrc(homeScreenImage)}
                    alt="Rat Race home screen"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
